import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
const Component = props => {
  return _jsx(_Fragment, {
    children: _jsxs("svg", Object.assign({
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props, {
      children: [_jsxs("g", {
        clipPath: "url(#4052eab4r__clip0_1_87261)",
        children: [_jsx("rect", {
          width: "20",
          height: "20",
          rx: "10",
          fill: "white"
        }), _jsxs("g", {
          clipPath: "url(#3swliz48c__clip1_1_87261)",
          children: [_jsx("path", {
            d: "M22.9054 -1.96823H-3.1275V21.9707H22.9054V-1.96823Z",
            fill: "#002B7F"
          }), _jsx("path", {
            d: "M22.9054 -1.96823H5.54974V21.9707H22.9054V-1.96823Z",
            fill: "#FCD116"
          }), _jsx("path", {
            d: "M22.9053 -1.96823H14.2281V21.9707H22.9053V-1.96823Z",
            fill: "#CE1126"
          })]
        })]
      }), _jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "19",
        height: "19",
        rx: "9.5",
        stroke: "black"
      }), _jsxs("defs", {
        children: [_jsx("clipPath", {
          id: "4052eab4r__clip0_1_87261",
          children: _jsx("rect", {
            width: "20",
            height: "20",
            rx: "10",
            fill: "white"
          })
        }), _jsx("clipPath", {
          id: "3swliz48c__clip1_1_87261",
          children: _jsx("rect", {
            width: "25.7778",
            height: "20",
            fill: "white",
            transform: "translate(-3)"
          })
        })]
      })]
    }))
  });
};
export default Component;
